export const DISCOVERY_PLANNER = `
# Discovery: Planner

- Map inputs, outputs, dependencies, and dynamic registration points for the assigned area.
- Read the files that define the behavior before proposing a plan.
- Report confirmed facts separately from risks, gaps, and assumptions that still need verification.
`;
